<template>
  <section class="section">
    <div class="container">
      <div class="box">
        <h1 class="title">ユーザー情報</h1>
        <router-link class="button is-primary" to="/settings/members/new">ユーザー新規登録</router-link>
      </div>
      <table class="table is-bordered pricing__table is-fullwidth">
        <thead>
          <tr>
            <th v-for="header in headers" v-bind:key="header.id">
              {{ header }}
            </th>
          </tr>
        </thead>
        <draggable v-model="myList" tag="tbody">
          <tr v-for="item in myList" :key="item.id">
            <td scope="row" class="cursor-drag">
              <span class="icon">
                <i class="fas fa-bars"></i>
              </span>
            </td>
            <td>{{ item.username }}</td>
            <td>{{ item.dispname }}</td>
            <td>
              <div v-if="JSON.parse(item.permissions).admin">
                管理者
              </div>
              <div v-if="JSON.parse(item.permissions).sub_admin">
                補助管理者
              </div>
            </td>
            <td v-if="item.deleted_at === '0'">利用中</td>
              <td v-else><span class="has-text-danger">利用停止中</span></td>
            <td>
              <router-link :to="{ name: 'editMember', params: { memberId: item.id }}">
                <button class="button is-link">編集</button>
              </router-link>
            </td>
          </tr>
        </draggable>
      </table>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'

export default {
  data: function () {
    return {
      headers:['', 'ログインID','表示名','権限', '状態', '操作'],
    }
  },
  components:{
    draggable,
  },
  computed: {
    myList: {
        get() {
          return this.list
        },
        set(val) {
          //並び替えをDBへ保存
          this.$store.dispatch('item/updateUserList', {list: val})
        }
    },
    ...mapState({
      list: state => state.item.users,
      apiStatus: state => state.item.apiStatus
    })
  },
  mounted () {
    this.$store.dispatch('item/getItems', {})
  },
}
</script>
<style scoped>
  .cursor-drag{
    cursor: move;
  }
</style>